module.exports = __webpack_public_path__ + "img/product_82.50afb4c.webp";